import styled from "@emotion/styled";

import TickIcon from "./icon-tick.svg";

export const Container = styled.div`
  display: flex;
`;

export const StyledTickIcon = styled(TickIcon)`
  flex: none;

  inline-size: 28px;
  block-size: 28px;
  margin-inline-end: 16px;
`;
